/** InsCoder 2026-03-30 B + Initialize Swiper for mobile glass cards **/
document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.cust-image-with-glass-card-overlay');
  
  sections.forEach(function(section) {
    const swiperContainer = section.querySelector('[data-glass-card-swiper]');
    if (!swiperContainer) return;

    let swiperInstance = null;

    function initSwiper() {
      if (window.innerWidth <= 768) {
        if (!swiperInstance) {
          // ensure Swiper is loaded before init
          if (typeof Swiper !== 'undefined') {
            swiperInstance = new Swiper(swiperContainer, {
              slidesPerView: '1.2',
              spaceBetween: 20,
              grabCursor: true,
            });
          } else {
            console.log("swiper fail")
            // retry after a small delay if Swiper is not yet available
            setTimeout(initSwiper, 100);
          }
        }
      } else {
        if (swiperInstance) {
          swiperInstance.destroy(true, true);
          swiperInstance = null;
        }
      }
    }

    initSwiper();
    window.addEventListener('resize', initSwiper);
  });
});
/** InsCoder 2026-03-30 E + Initialize Swiper for mobile glass cards **/
